import './constants.js';
import Vue from 'vue';
import App from './App';
import ElementUI, {Message, MessageBox} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import './assets/theme/theme-green/index.css'
import 'es6-promise/auto'
import './assets/theme/theme-darkblue/index.css'
import VueRouter from 'vue-router';
import store from './vuex/store';
import Vuex from 'vuex';
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
// import Mock from './mock';
import 'font-awesome/css/font-awesome.min.css';
import {baseUrl, mainPage, sysName} from '../config/config'
import {axiosObj} from '../src/common/base/_axios'
import {constants} from "./constants";
import router from "./routes";

// Mock.bootstrap();

Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(Vuex);

document.getElementById("index_sys_title").innerText = sysName;


axiosObj._axios.interceptors.request.use(config => {
    return config;
}, error => {
    Message.error({
        message: '网络不给力,请稍后再试'
    });
    return Promise.reject(error);
});

//   http响应拦截器
axiosObj._axios.interceptors.response.use(success => {
    return success;
}, error => {
    Message.error({
        message: '网络不给力,请稍后再试'
    });
    if (error && error.response) {
        if (error.response.status === 401) {
            MessageBox.alert('登录超时', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                    router.replace({
                        path: baseUrl + 'login',
                        query: {redirect: router.currentRoute.fullPath}
                    })
                }
            });
        } else if (error.response.status === 311) {
            MessageBox.alert('账号在其他设备登录', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                    router.replace({
                        path: baseUrl + 'login',
                        query: {redirect: router.currentRoute.fullPath}
                    })
                }
            });
        }
    }
    return Promise.reject(error);
});

new Vue({
    //el: '#app',
    //template: '<App/>',
    router,
    store,
    //components: { App }
    render: h => h(App)
}).$mount('#app');
// NProgress.configure({ showSpinner: false });



// WEBPACK FOOTER //
// ./src/main.js